<template>
  <div class="d-flex align-center flex-column">
    <v-card>
      <!-- Toolbar superior -->
      <s-toolbar label="Historia Clínica Ocupacional" dark :color="'#8e8f91'" close @close="$emit('close')"
        class="mb-6" />

      <v-card-title style="font-size: small;">
        <v-row>
          <v-col align="right">
            <!-- Descargar/Imprimir local -->
            <v-btn fab style="margin-right: 40px;" x-small color="warning" @click="downloadPdf(1)">
              <v-icon medium>mdi-printer</v-icon>
            </v-btn>
            <v-btn small color="primary" style="margin-right: 20px;" @click="downloadBlank()">
              <v-icon small left>mdi-file-outline</v-icon>Formato en blanco
            </v-btn>

            <!-- Guardar PDF en servidor (routeClinicHistories) -->
            <!-- <v-btn fab style="margin-right: 40px;" x-small color="info" @click="downloadPdf(0)">
              <v-icon medium>mdi-folder-download</v-icon>
            </v-btn> -->
          </v-col>
        </v-row>
      </v-card-title>

      <!-- NUEVO FORMATO PDF: Basado en HistoryEditNew.vue -->
      <vue-html2pdf :show-layout="true" :float-layout="false" :enable-download="false" :preview-modal="false"
        :filename="pdfFileName" :paginate-elements-by-height="60" :pdf-quality="2" pdf-format="a4"
        pdf-orientation="portrait" pdf-content-width="725px" :manual-pagination="true" :margin="0.0"
        :htmlToPdfOptions="htmlToPdfOptions" @beforeDownload="beforeDownload($event)" @progress="onProgress($event)"
        ref="html2Pdf">
        <section slot="pdf-content" style="margin: 0;">
          <div class="formato-medico-container">
            <div class="formato-medico">
              <div class="page" style="page-break-after: always;">
        <table class="header-table">
                        <tr>
                          <td style="
                            width: 25%;
                            vertical-align: middle;
                            text-align: left;
                            border: none;
                            padding: 10px;
                          ">
                            <img src="/static/logo_sp.png" alt="Logo" style="width: 140px; height: auto" />
                          </td>
                          <td style="width: 45%; text-align: center; vertical-align: middle; border: none">
                            <div class="title">CONSENTIMIENTO INFORMADO PARA</div>
                            <div class="title">EXAMEN MÉDICO OCUPACIONAL</div>
                            <div class="title">DE PRE – INGRESO</div>
                          </td>
                          <td style="width: 30%; text-align: left; vertical-align: middle; border: none; padding: 8px; font-size: 8pt;">

                            <document-header-control param-name="PdfClinicConsent" :default-data="{
                              codigo: 'SIG-ST-SO-FR-004',
                              version: '05',
                              fechaCreacion: '28/09/2018',
                              ultimaRevision: '15/07/2025',
                            }" />
                             <div style="margin-top: 4px;"><strong>Páginas:</strong> 1 de 1</div>
                            <div style="margin-top: 2px;"><strong>Anexos:</strong> 00</div>
                          </td>

                        </tr>
                      </table>

        <div style="padding: 80px; text-align: justify; font-size: 14px; line-height: 1.5; ">
          <p>
            Yo, <b>{{ blankMode ? blankLine : viewHistory.NtpFullName }}</b>, identificado con DNI N° <b>{{ blankMode ? blankLine : viewHistory.PrsDocumentNumber }}</b>,
            AUTORIZO LA REALIZACIÓN DEL EXAMEN MEDICO OCUPACIONAL DE PRE-INGRESO SOLICITADO POR SUNSHINE EXPORT S.A.C
            HABIENDO SIDO PREVIAMENTE INFORMADO DE LA FINALIDAD DEL MISMO.
          </p>
          <br>
          <p>
            DOY FE QUE LA INFORMACIÓN QUE BRINDO DURANTE LA ENTREVISTA MÉDICA ES COMPLETAMENTE CIERTA (Proporcionar
            falsa
            información al empleador está tipificado como falta grave, según lo dispuesto en el inciso D, del artículo
            25
            del TUO de la ley de Productividad y competitividad laboral).
          </p>
          <br>
          <p>
            ASI MISMO DOY MI CONSENTIMIENTO PARA QUE EL MÉDICO OCUPACIONAL Y PERSONAL DEL ÁREA DE SSO DE LA EMPRESA
            SUNSHINE
            EXPORT S.A.C CUSTODIE Y TENGA ACCESO A LA INFORMACIÓN BRINDADA POR MI PERSONA.
          </p>
        </div>

        <!-- FIRMA CONSENTIMIENTO -->
        <div style="flex: 1; margin-top: 30px; display: flex; justify-content: center;">
          <div
            style="font-size: 12px; display: flex; flex-direction: column; justify-content: center; align-items: center; position: relative; margin: 0;">
          <div
            style="display: flex; flex-direction: column; justify-content: center; align-items: center; position: relative; max-width: max-content;">
            <div
              style="width: 100%; height: 80px; display: flex; justify-content: center; align-items: center; position: relative; margin-bottom: 6px;">
              <div style="width: 100%; display: flex;">
                <div
                  style="display: flex; flex-direction: column; justify-content: center; align-items: center; width: 100%; cursor: pointer;"
                  >
                  <span v-if="!SignaturePatient && !SignaturePatientDB" style="height:80px; width: 100%;"></span>
                  <img :src="SignaturePatient" v-if="SignaturePatient" alt="Firma Paciente"
                    style="max-width: 100%; height: 80px; object-fit: contain; " />
                  <img :src="SignaturePatientDB" v-if="!SignaturePatient && SignaturePatientDB" alt="Firma Paciente"
                    style="max-width: 100%; height: 80px; object-fit: contain;" />
                </div>
                <div
                  style="width: 60px; height: 80px; border: 1px solid #000; text-align: center; display: flex; justify-content: center; align-items: center;">
                  <!-- fingerPrintPatient, fingerPrintPatientDB -->
                  <img :src="FingerPrintPatient" v-if="FingerPrintPatient" alt="Firma Paciente"
                                  style="max-width: 100%; height: 80px; object-fit: contain;" />
                                <img :src="FingerPrintPatientDB" v-if="!FingerPrintPatient && FingerPrintPatientDB"
                                  alt="Firma Paciente"
                                  style="max-width: 100%; height: 80px; object-fit: contain;" />
                </div>
              </div>
            </div>
            <span style="border-top: 1px solid #000;">
              &nbsp;&nbsp;&nbsp;&nbsp;
              <span style="font-weight: bold;">Nombre : </span>{{ blankMode ? blankLine : viewHistory.NtpFullName }}&nbsp;&nbsp;&nbsp;&nbsp;
            </span>
            <span><span style="font-weight: bold;">DNI : </span>{{ blankMode ? blankLine : viewHistory.PrsDocumentNumber }}</span>
            <span><span style="font-weight: bold;">Fecha : </span>{{ blankMode ? blankLine : $fun.formatDateView(viewHistory.MevDate) }}</span>
          </div>
          </div>
        </div>

      </div>
              <div class="page" style="page-break-after: always;   text-transform: uppercase;">
                <div class="watermark">DOCUMENTO CONTROLADO</div>
                <!-- ENCABEZADO -->
                <table class="header-table" style="width: 100%; border-collapse: collapse;">
                  <tr>
                    <td style="
                      width: 20%;
                      vertical-align: middle;
                      text-align: center;
                      border: none;
                      padding: 8px;
                    ">
                      <img src="/static/logo_sp.png" alt="Logo" style="width: 120px; height: auto" />
                    </td>
                    <td style="width: 50%; text-align: center; vertical-align: middle; border: none; padding: 8px;">
                      <div class="title" style="font-size: 11px; font-weight: bold; line-height: 1.3;">FORMATO PARA EXAMEN</div>
                      <div class="title" style="font-size: 11px; font-weight: bold; line-height: 1.3;">MÉDICO OCUPACIONAL DE</div>
                      <div class="title" style="font-size: 11px; font-weight: bold; line-height: 1.3;">PRE – INGRESO</div>
                    </td>
                    <td style="width: 30%; text-align: left; vertical-align: middle; border: none; padding: 8px; font-size: 9pt; line-height: 1.5;">
                      <document-header-control param-name="PdfClinicHistory" :default-data="{
                        codigo: 'SIG-ST-SO-FR-003',
                        version: '08',
                        fechaCreacion: '28/10/2018',
                        ultimaRevision: '14/07/2025',
                      }" />
                      <div style="margin-top: 4px;"><strong>PÁGINAS:</strong> 1 DE 3</div>
                      <div style="margin-top: 2px;"><strong>ANEXOS:</strong> 00</div>
                    </td>
                  </tr>
                </table>

                <!-- SECCIÓN OBSERVADO Y RESULTADOS -->
                <table style="width: 100%; max-width: 100%; border-collapse: collapse; margin: 0 auto 8px auto; font-size: 8pt;">
                  <tr>
                    <td style="width: 28%; vertical-align: top; padding: 2px;">
                      <table style="width: 100%; border-collapse: collapse; font-size: 7.5pt;">
                        <tr>
                          <td class="subtitle" style="text-align: center; padding: 2px;">OBSERVADO</td>
                        </tr>
                        <tr>
                          <td style="border: 1px solid black; text-align: center; padding: 2px; height: 28px;">
                            <input type="radio" v-if="!blankMode" disabled :value="4" v-model="viewHistory.MevStatus"
                              style="transform: scale(0.8);" />
                          </td>
                        </tr>
                      </table>
                    </td>
                    <td style="width: 4%; vertical-align: top; padding: 2px"></td>
                    <td style="width: 68%; vertical-align: top; padding: 2px">
                      <table style="width: 100%; border-collapse: collapse; font-size: 7.5pt;">
                        <tr>
                          <td class="subtitle" style="width: 33.33%; text-align: center; padding: 2px;">APTO</td>
                          <td class="subtitle" style="width: 33.33%; text-align: center; padding: 2px;">APTO
                            C/RESTRICCIÓN</td>
                          <td class="subtitle" style="width: 33.34%; text-align: center; padding: 2px;">NO APTO</td>
                        </tr>
                        <tr>
                          <td style="border: 1px solid black; text-align: center; padding: 2px; height: 28px;">
                            <input type="radio" v-if="!blankMode" disabled :value="1" v-model="viewHistory.MevStatus"
                              style="transform: scale(0.8);" />
                          </td>
                          <td style="border: 1px solid black; text-align: center; padding: 2px; height: 28px;">
                            <input type="radio" v-if="!blankMode" disabled :value="2" v-model="viewHistory.MevStatus"
                              style="transform: scale(0.8);" />
                          </td>
                          <td style="border: 1px solid black; text-align: center; padding: 2px; height: 28px;">
                            <input type="radio" v-if="!blankMode" disabled :value="3" v-model="viewHistory.MevStatus"
                              style="transform: scale(0.8);" />
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>

                <!-- TABLA PRINCIPAL DE DATOS -->
                <table class="data-table" style="font-size: 8pt; width: 100%; max-width: 100%; table-layout: fixed; margin: 0 auto;">
                  <tr>
                    <td colspan="10">
                      <b>FECHA/HORA DE EXAMEN DE PRE INGRESO:</b> {{ blankMode ? '' : this.$fun.formatDateView(viewHistory.MevDate) }} {{
                        this.$fun.formatTimeShortView(viewHistory.MevDate + ' ' + viewHistory.MevTime) }}
                    </td>
                    <td colspan="6">
                      <b>N° DE FICHA MEDICA:</b>
                      {{ viewHistory.MevDocumentNumber }}
                    </td>
                  </tr>
                  <!-- 1) DATOS DEL EMPLEADOR -->
                  <tr>
                    <td class="subtitle" colspan="16" style="text-align: center">1) DATOS DEL EMPLEADOR</td>
                  </tr>
                  <tr>
                    <td colspan="8"><b>RAZÓN SOCIAL:</b> SUNSHINE EXPORT S.A.C.</td>
                    <td colspan="8"><b>DIRECCIÓN:</b> CARRETERA TAMBOGRANDE LAS LOMAS KM 1077 + 179 MTS</td>
                  </tr>
                  <tr style="text-align: center">
                    <td colspan="2"><b>RUC:</b><br />20329725431</td>
                    <td colspan="2"><b>TELÉFONO/FAX:</b><br />073 313709</td>
                    <td colspan="4"><b>SECTOR:</b><br />AGRARIO</td>
                    <td colspan="4"><b>ACTIVIDAD:</b><br />AGROINDUSTRIAL</td>
                    <td colspan="4"><b>LUGAR:</b><br />TAMBOGRANDE</td>
                  </tr>
                  <!-- 2) DATOS PERSONALES -->
                  <tr>
                    <td class="subtitle" colspan="16" style="text-align: center">2) DATOS PERSONALES</td>
                  </tr>
                  <tr>
                    <td colspan="10"><b>APELLIDOS Y NOMBRES:</b> {{ viewHistory.NtpFullName }}</td>
                    <td colspan="2"><b>GÉNERO:</b></td>
                    <td colspan="2" style="text-align: center; width: 30px;">M <input type="radio" v-if="!blankMode" disabled value="1"
                        v-model="viewHistory.TypeSex" style="transform: scale(0.8);" /></td>
                    <td colspan="2" style="text-align: center; width: 30px;">F <input type="radio" v-if="!blankMode" disabled value="2"
                        v-model="viewHistory.TypeSex" style="transform: scale(0.8);" /></td>
                  </tr>
                  <tr>
                    <td colspan="5"><b>FECHA DE NACIMIENTO:</b> {{ blankMode ? '' : this.$fun.formatDateView(viewHistory.NtpBirthDate) }}
                    </td>
                    <td colspan="4"><b>EDAD:</b> {{ viewHistory.NtpAge }}</td>
                    <td colspan="7"><b>ESTADO CIVIL:</b>
                      {{ viewHistory.TypeCivilName }}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="9"><b>GRADO DE INSTRUCCIÓN:</b> {{ viewHistory.TypeEducationName }}
                    </td>
                    <td colspan="3"><b>DNI:</b> {{ viewHistory.PrsDocumentNumber }}</td>
                    <td colspan="4"><b>CELULAR:</b>
                      {{ viewHistory.MevPhoneNumber }}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="5"><b>ÁREA AL QUE POSTULA:</b>
                      {{ viewHistory.AreName }}
                    </td>
                    <td colspan="5"><b>PUESTO AL QUE POSTULA:</b>
                      {{ viewHistory.PstName }}
                    </td>
                    <td colspan="6"><b>TIEMPO DE EXPERIENCIA LABORANDO:</b>
                      <div style="display: flex; align-items: center;">
                        {{ viewHistory.TypeExpMesureName }}&nbsp;
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <b>N° HIJOS:</b> 
                    </td>
                    <td>VIVOS</td>
                    <td style="text-align: center;">{{ viewHistory.MevChildLiving }}</td>
                    <td colspan="2">MUERTOS</td>
                    <td style="text-align: center;">{{ viewHistory.MevChildDead }}</td>
                    <td colspan="2">ÓBITOS FETALES</td>
                    <td style="text-align: center;">{{ viewHistory.MevFetalDeaths }}</td>
                    <td colspan="2">ABORTOS</td>
                    <td style="text-align: center;">{{ viewHistory.MevChildAborted }}</td>
                    <td colspan="2"><b>HIJOS DEPENDIENTES</b></td>
                    <td style="text-align: center;">{{ viewHistory.MevChildDepend }}</td>
                  </tr>

                  <!-- 3) ANTECEDENTES -->
                  <tr>
                    <td class="subtitle" colspan="16" style="text-align: center">
                      3) ANTECEDENTES PERSONALES Y FAMILIARES PATOLÓGICOS
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <b>ALERGIAS:</b>
                    </td>
                    <td colspan="1">
                        <span
                        v-if="viewHistory.MevIsAllergy == 1"
                        style="display: inline-block; min-width: 20px; height: 20px; border: 2px solid #222; border-radius: 4px; text-align: center; line-height: 22px; font-size: 16px; font-weight: bold;"
                      >
                        ✔
                      </span>
                      <span
                        v-else
                        style="display: inline-block; min-width: 20px; height: 20px; border: 2px solid #222; border-radius: 4px; text-align: center; line-height: 22px; font-size: 16px; font-weight: bold;"
                      >
                        {{ blankMode ? '' : '✗' }}
                      </span>
                    </td>
                    <td colspan="13">
                      <div v-if="viewHistory.MevIsAllergy == 1" style="display: flex; flex-wrap: wrap">
                        <div style="
                    display: flex;
                    align-items: center;
                    margin-right: 20px;
                    width: 45%;
                  ">
                          <b style="margin-right: 5px">ALIMENTARIAS:</b>

                            <span
                        v-if="viewHistory.MevFoodAllergy == 1"
                        style="display: inline-block; min-width: 20px; height: 20px; border: 2px solid #222; border-radius: 4px; text-align: center; line-height: 22px; font-size: 16px; font-weight: bold;"
                      >
                        ✔
                      </span>
                      <span
                        v-else
                        style="display: inline-block; min-width: 20px; height: 20px; border: 2px solid #222; border-radius: 4px; text-align: center; line-height: 22px; font-size: 16px; font-weight: bold;"
                      >
                        {{ blankMode ? '' : '✗' }}
                      </span>
                          <div v-if="viewHistory.MevFoodAllergy" style="width: 100%; text-align: center;">
                            {{ viewHistory.MevFoodAllergyText }}
                          </div>
                        </div>
                        <div style="display: flex; align-items: center; width: 45%">
                          <b style="margin-right: 5px">MEDICAMENTOSAS:</b>

                          <span
                        v-if="viewHistory.MevMedicationAllergy == 1"
                        style="display: inline-block; min-width: 20px; height: 20px; border: 2px solid #222; border-radius: 4px; text-align: center; line-height: 22px; font-size: 16px; font-weight: bold;"
                      >
                        ✔
                      </span>
                      <span
                        v-else
                        style="display: inline-block; min-width: 20px; height: 20px; border: 2px solid #222; border-radius: 4px; text-align: center; line-height: 22px; font-size: 16px; font-weight: bold;"
                      >
                        {{ blankMode ? '' : '✗' }}
                      </span>
                            <div v-if="viewHistory.MevMedicationAllergy" style="width: 100%; text-align: center;">
                              {{ viewHistory.MevMedicationAllergyText }}
                            </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <b>TBC:</b>
                    </td>
                    <td>
                        <span
                        v-if="viewHistory.MevIsTuberculosis == 1"
                        style="display: inline-block; min-width: 20px; height: 20px; border: 2px solid #222; border-radius: 4px; text-align: center; line-height: 22px; font-size: 16px; font-weight: bold;"
                      >
                        ✔
                      </span>
                      <span
                        v-else
                        style="display: inline-block; min-width: 20px; height: 20px; border: 2px solid #222; border-radius: 4px; text-align: center; line-height: 22px; font-size: 16px; font-weight: bold;"
                      >
                        {{ blankMode ? '' : '✗' }}
                      </span>
                    </td>
                    <td colspan="3">
                      <b>BRONQUITIS CRÓNICA:</b>
                    </td>
                    <td colspan="3">
                        <span
                        v-if="viewHistory.MevIsChronicBronchitis == 1"
                        style="display: inline-block; min-width: 20px; height: 20px; border: 2px solid #222; border-radius: 4px; text-align: center; line-height: 22px; font-size: 16px; font-weight: bold;"
                      >
                        ✔
                      </span>
                      <span
                        v-else
                        style="display: inline-block; min-width: 20px; height: 20px; border: 2px solid #222; border-radius: 4px; text-align: center; line-height: 22px; font-size: 16px; font-weight: bold;"
                      >
                        {{ blankMode ? '' : '✗' }}
                      </span>
                    </td>
                    <td colspan="3">
                      <b>CONVULSIONES:</b>
                    </td>
                    <td colspan="4">
                        <span
                        v-if="viewHistory.MevIsSeizures == 1"
                        style="display: inline-block; min-width: 20px; height: 20px; border: 2px solid #222; border-radius: 4px; text-align: center; line-height: 22px; font-size: 16px; font-weight: bold;"
                      >
                        ✔
                      </span>
                      <span
                        v-else
                        style="display: inline-block; min-width: 20px; height: 20px; border: 2px solid #222; border-radius: 4px; text-align: center; line-height: 22px; font-size: 16px; font-weight: bold;"
                      >
                        {{ blankMode ? '' : '✗' }}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <b>DIABETES:</b>
                    </td>
                    <td>
                        <span
                        v-if="viewHistory.MevIsDiabetes == 1"
                        style="display: inline-block; min-width: 20px; height: 20px; border: 2px solid #222; border-radius: 4px; text-align: center; line-height: 22px; font-size: 16px; font-weight: bold;"
                      >
                        ✔
                      </span>
                      <span
                        v-else
                        style="display: inline-block; min-width: 20px; height: 20px; border: 2px solid #222; border-radius: 4px; text-align: center; line-height: 22px; font-size: 16px; font-weight: bold;"
                      >
                        {{ blankMode ? '' : '✗' }}
                      </span>
                    </td>
                    <td colspan="2">
                      <b>HTA:</b>
                    </td>
                    <td>
                        <span
                        v-if="viewHistory.MevIsBloodPressure == 1"
                        style="display: inline-block; min-width: 20px; height: 20px; border: 2px solid #222; border-radius: 4px; text-align: center; line-height: 22px; font-size: 16px; font-weight: bold;"
                      >
                        ✔
                      </span>
                      <span
                        v-else
                        style="display: inline-block; min-width: 20px; height: 20px; border: 2px solid #222; border-radius: 4px; text-align: center; line-height: 22px; font-size: 16px; font-weight: bold;"
                      >
                        {{ blankMode ? '' : '✗' }}
                      </span>
                    </td>
                    <td colspan="3">
                      <b>NEOPLASIA:</b>
                    </td>
                    <td colspan="3">
                        <span
                        v-if="viewHistory.MevIsNeoplasm == 1"
                        style="display: inline-block; min-width: 20px; height: 20px; border: 2px solid #222; border-radius: 4px; text-align: center; line-height: 22px; font-size: 16px; font-weight: bold;"
                      >
                        ✔
                      </span>
                      <span
                        v-else
                        style="display: inline-block; min-width: 20px; height: 20px; border: 2px solid #222; border-radius: 4px; text-align: center; line-height: 22px; font-size: 16px; font-weight: bold;"
                      >
                        {{ blankMode ? '' : '✗' }}
                      </span>
                    </td>
                    <td colspan="3">
                      <b>ASMA:</b>
                    </td>
                    <td>
                        <span
                        v-if="viewHistory.MevIsAsthma == 1"
                        style="display: inline-block; min-width: 20px; height: 20px; border: 2px solid #222; border-radius: 4px; text-align: center; line-height: 22px; font-size: 16px; font-weight: bold;"
                      >
                        ✔
                      </span>
                      <span
                        v-else
                        style="display: inline-block; min-width: 20px; height: 20px; border: 2px solid #222; border-radius: 4px; text-align: center; line-height: 22px; font-size: 16px; font-weight: bold;"
                      >
                        {{ blankMode ? '' : '✗' }}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <b>HEPATITIS:</b>
                    </td>
                    <td>
                        <span
                        v-if="viewHistory.MevIsHepatitis == 1"
                        style="display: inline-block; min-width: 20px; height: 20px; border: 2px solid #222; border-radius: 4px; text-align: center; line-height: 22px; font-size: 16px; font-weight: bold;"
                      >
                        ✔
                      </span>
                      <span
                        v-else
                        style="display: inline-block; min-width: 20px; height: 20px; border: 2px solid #222; border-radius: 4px; text-align: center; line-height: 22px; font-size: 16px; font-weight: bold;"
                      >
                        {{ blankMode ? '' : '✗' }}
                      </span>
                    </td>
                    <td colspan="2">
                      <b>ETS:</b>
                    </td>
                    <td>
                        <span
                        v-if="viewHistory.MevIsEts == 1"
                        style="display: inline-block; min-width: 20px; height: 20px; border: 2px solid #222; border-radius: 4px; text-align: center; line-height: 22px; font-size: 16px; font-weight: bold;"
                      >
                        ✔
                      </span>
                      <span
                        v-else
                        style="display: inline-block; min-width: 20px; height: 20px; border: 2px solid #222; border-radius: 4px; text-align: center; line-height: 22px; font-size: 16px; font-weight: bold;"
                      >
                        {{ blankMode ? '' : '✗' }}
                      </span>
                    </td>
                    <td colspan="10">
                      <b>CIRUGIAS:</b>
                      {{ viewHistory.MevDescriptionSurgery }}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="16">
                      <b>OTROS:</b>
                      {{ viewHistory.MevOtherPathology }}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="16">
                      <b>ANTECEDENTES FAMILIARES:</b>
                      {{ viewHistory.MevFamilyAntecedents }}
                    </td>
                  </tr>
                  <tr>
                    <td :colspan="viewHistory.TypeSex == 2 ? '12' : '16'">
                      <b>OBSERVACIONES</b> (OTRAS ENFERMEDADES, MEDICAMENTOS QUE CONSUME
                      HABITUALMENTE, ETC):
                      {{ viewHistory.MevObservationPathology }}
                    </td>
                    <td :colspan="viewHistory.TypeSex == 2 ? '4' : '0'" style="vertical-align: top"
                      v-show="viewHistory.TypeSex == 2">
                      <div style="margin-bottom: 10px">
                        <b>FUR:</b>
                        {{ viewHistory.MevDateFUR }}
                      </div>
                      <div>
                        <b>MAC:</b>
                        {{ viewHistory.MevMAC }}
                      </div>
                    </td>
                  </tr>

                  <!-- 4) EXAMEN MENTAL -->
                  <tr>
                    <td class="subtitle" colspan="16" style="text-align: center">
                      4) EXAMEN MENTAL
                    </td>
                  </tr>
                  <tr>
                    <td colspan="8" style="
                text-align: center;
                background-color: #e9e9e9;
                font-weight: bold;
                width: 50%;
              ">
                      OBSERVACIÓN DE CONDUCTAS
                    </td>
                    <td colspan="8" style="
                text-align: center;
                background-color: #e9e9e9;
                font-weight: bold;
                width: 50%;
              ">
                      PROCESOS COGNITIVOS
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">PRESENTACIÓN:</td>
                    <td colspan="2">ADECUADO</td>
                    <td>
                      <input type="radio" v-if="!blankMode" disabled :value="1" v-model="viewHistory.MevMentalPresentation" />
                    </td>
                    <td colspan="2">INADECUADO</td>
                    <td>
                      <input type="radio" v-if="!blankMode" disabled :value="2" v-model="viewHistory.MevMentalPresentation" />
                    </td>
                    <td colspan="8">
                      LUCIDO, ATENTO: <br />
                      LOTEP
                      <input type="radio" v-if="!blankMode" disabled :value="1" v-model="viewHistory.MevMentalLucidity" />
                      NO LOTEP
                      <input type="radio" v-if="!blankMode" disabled :value="0" v-model="viewHistory.MevMentalLucidity" />
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">POSTURA:</td>
                    <td colspan="2">ERGUIDA</td>
                    <td>
                      <input type="radio" v-if="!blankMode" disabled :value="1" v-model="viewHistory.MevMentalPosture" />
                    </td>
                    <td colspan="2">ENCORVADA</td>
                    <td>
                      <input type="radio" v-if="!blankMode" disabled :value="2" v-model="viewHistory.MevMentalPosture" />
                    </td>
                    <td colspan="8">
                      PENSAMIENTO:<br />
                      NORMAL
                      <input type="radio" v-if="!blankMode" disabled :value="1" v-model="viewHistory.MevMentalThought" />
                      ALTERADO
                      <input type="radio" v-if="!blankMode" disabled :value="0" v-model="viewHistory.MevMentalThought" />
                    </td>
                  </tr>
                  <tr>
                    <td>DISCURSO:</td>
                    <td>LENTO</td>
                    <td>
                      <input type="radio" v-if="!blankMode" disabled :value="1" v-model="viewHistory.MevMentalLanguage" />
                    </td>
                    <td colspan="2">MODERADO</td>
                    <td>
                      <input type="radio" v-if="!blankMode" disabled :value="2" v-model="viewHistory.MevMentalLanguage" />
                    </td>
                    <td>RÁPIDO</td>
                    <td>
                      <input type="radio" v-if="!blankMode" disabled :value="3" v-model="viewHistory.MevMentalLanguage" />
                    </td>
                    <td colspan="8">
                      PERCEPCIÓN:<br />
                      NORMAL
                      <input type="radio" v-if="!blankMode" disabled :value="1" v-model="viewHistory.MevMentalPerception" />
                      ALTERADO
                      <input type="radio" v-if="!blankMode" disabled :value="0" v-model="viewHistory.MevMentalPerception" />
                    </td>
                  </tr>
                  <tr>
                    <td>TONO:</td>
                    <td>BAJO</td>
                    <td>
                      <input type="radio" v-if="!blankMode" disabled :value="1" v-model="viewHistory.MevMentalPitch" />
                    </td>
                    <td colspan="2">MODERADO</td>
                    <td>
                      <input type="radio" v-if="!blankMode" disabled :value="2" v-model="viewHistory.MevMentalPitch" />
                    </td>
                    <td>ALTO</td>
                    <td>
                      <input type="radio" v-if="!blankMode" disabled :value="3" v-model="viewHistory.MevMentalPitch" />
                    </td>
                    <td colspan="2">
                      <b>MEMORIA:</b> <br />
                      CORTO PLAZO
                    </td>
                    <td>
                      <input type="radio" v-if="!blankMode" disabled :value="1" v-model="viewHistory.MevMentalMemory" />
                    </td>
                    <td colspan="2">MEDIANO PLAZO</td>
                    <td>
                      <input type="radio" v-if="!blankMode" disabled :value="2" v-model="viewHistory.MevMentalMemory" />
                    </td>
                    <td>
                      <label for="longTermMemory">LARGO PLAZO</label>
                    </td>
                    <td>
                      <input type="radio" v-if="!blankMode" disabled :value="3" v-model="viewHistory.MevMentalMemory" name="longTermMemory" />
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">ARTICULACION</td>
                    <td colspan="2">SIN DIFICULTAD</td>
                    <td>
                      <input type="radio" v-if="!blankMode" disabled :value="0" v-model="viewHistory.MevMentalArticulation" />
                    </td>
                    <td colspan="2">CON DIFICULTAD</td>
                    <td>
                      <input type="radio" v-if="!blankMode" disabled :value="1" v-model="viewHistory.MevMentalArticulation" />
                    </td>
                    <td colspan="2">
                      <b>INTELIGENCIA:</b> <br />
                      SUPERIOR
                    </td>
                    <td>
                      <input type="radio" v-if="!blankMode" disabled :value="1" v-model="viewHistory.MevMentalInteligence" />
                    </td>
                    <td colspan="2">MODERADO</td>
                    <td>
                      <input type="radio" v-if="!blankMode" disabled :value="2" v-model="viewHistory.MevMentalInteligence" />
                    </td>
                    <td>
                      <label for="longTermMemory">LEVE</label>
                    </td>
                    <td>
                      <input type="radio" v-if="!blankMode" disabled :value="3" v-model="viewHistory.MevMentalInteligence"
                        name="longTermMemory" />
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">ORIENTACIÓN: TIEMPO</td>
                    <td colspan="2">ORIENTADO</td>
                    <td>
                      <input type="radio" v-if="!blankMode" disabled :value="1" v-model="viewHistory.MevMentalOrientationTime" />
                    </td>
                    <td colspan="3">DESORIENTADO</td>
                    <td>
                      <input type="radio" v-if="!blankMode" disabled :value="0" v-model="viewHistory.MevMentalOrientationTime" />
                    </td>
                    <td colspan="7">
                      ANT. PSICOLOGICOS:
                      {{ viewHistory.MevMentalPsychologicalAnt }}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">ESPACIO:</td>
                    <td colspan="2">ORIENTADO</td>
                    <td>
                      <input type="radio" v-if="!blankMode" disabled :value="1" v-model="viewHistory.MevMentalOrientationSpace" />
                    </td>
                    <td colspan="3">DESORIENTADO</td>
                    <td>
                      <input type="radio" v-if="!blankMode" disabled :value="0" v-model="viewHistory.MevMentalOrientationSpace" />
                    </td>
                    <td colspan="7">
                      ANT. PSIQUIÁTRICOS:
                      {{ viewHistory.MevMentalPsychiatricAnt }}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">PERSONA</td>
                    <td colspan="2">ORIENTADO</td>
                    <td>
                      <input type="radio" v-if="!blankMode" disabled :value="1" v-model="viewHistory.MevMentalOrientationPerson" />
                    </td>
                    <td colspan="3">DESORIENTADO</td>
                    <td>
                      <input type="radio" v-if="!blankMode" disabled :value="0" v-model="viewHistory.MevMentalOrientationPerson" />
                    </td>
                    <td colspan="7"></td>
                  </tr>

                  <!-- 5) HÁBITOS NOCIVOS -->
                  <tr>
                    <td class="subtitle" colspan="16" style="text-align: center">
                      5) HÁBITOS NOCIVOS
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">ALCOHOL</td>
                    <td colspan="2">
                      SI
                      <input type="radio" v-if="!blankMode" disabled :value="1" v-model="viewHistory.MevAlcoholType" />
                      NO
                      <input type="radio" v-if="!blankMode" disabled :value="0" v-model="viewHistory.MevAlcoholType" />
                    </td>
                    <td colspan="6">
                      <div v-show="viewHistory.MevAlcoholType == 1">
                        {{ viewHistory.TypeAlcoholName }}
                      </div>
                      <div v-show="viewHistory.MevAlcoholType == 0" style="font-weight: bold; margin-top: 5px">
                        NIEGA
                      </div>
                    </td>
                    <td colspan="6">
                      <div v-show="viewHistory.MevAlcoholType == 1">
                        {{ viewHistory.TypeAlcoholFrecuencyName }}
                      </div>
                      <div v-show="viewHistory.MevAlcoholType == 0" style="font-weight: bold; margin-top: 5px">
                        NIEGA
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">CIGARRILLO</td>
                    <td colspan="2">
                      SI
                      <input type="radio" v-if="!blankMode" disabled :value="1" v-model="viewHistory.MevTobaccoType" />
                      NO
                      <input type="radio" v-if="!blankMode" disabled :value="0" v-model="viewHistory.MevTobaccoType" />
                    </td>
                    <td colspan="6">
                      <div v-show="viewHistory.MevTobaccoType == 1">
                        {{ viewHistory.TypeTobaccoName }}
                      </div>

                      <div v-show="viewHistory.MevTobaccoType == 0" style="font-weight: bold; margin-top: 5px">
                        NIEGA
                      </div>
                    </td>
                    <td colspan="6">
                      <div v-show="viewHistory.MevTobaccoType == 1">
                        {{ viewHistory.TypeTobaccoFrequencyName }}
                      </div>
                      <div v-show="viewHistory.MevTobaccoType == 0" style="font-weight: bold; margin-top: 5px">
                        NIEGA
                      </div>
                    </td>
                  </tr>

                  </table>
              </div>
              <div class="page" style="page-break-after: always; text-transform: uppercase;">
                <div class="watermark">DOCUMENTO CONTROLADO</div>
                  <table class="data-table" style="font-size: 8pt; width: 100%; max-width: 100%; table-layout: fixed; margin: 0 auto;">
                  <!-- 6) ACCIDENTES -->
                  <tr>
                    <td colspan="16" style="padding:0; border:none;">
                      <table class="header-table" style="width: 100%; border-collapse: collapse;">
                  <tr>
                    <td style="
                      width: 20%;
                      vertical-align: middle;
                      text-align: center;
                      border: none;
                      padding: 8px;
                    ">
                      <img src="/static/logo_sp.png" alt="Logo" style="width: 120px; height: auto" />
                    </td>
                    <td style="width: 50%; text-align: center; vertical-align: middle; border: none; padding: 8px;">
                      <div class="title" style="font-size: 11px; font-weight: bold; line-height: 1.3;">FORMATO PARA EXAMEN</div>
                      <div class="title" style="font-size: 11px; font-weight: bold; line-height: 1.3;">MÉDICO OCUPACIONAL DE</div>
                      <div class="title" style="font-size: 11px; font-weight: bold; line-height: 1.3;">PRE – INGRESO</div>
                    </td>
                    <td style="width: 30%; text-align: left; vertical-align: middle; border: none; padding: 8px; font-size: 9pt; line-height: 1.5;">
                      <document-header-control param-name="PdfClinicHistory" :default-data="{
                        codigo: 'SIG-ST-SO-FR-003',
                        version: '08',
                        fechaCreacion: '28/10/2018',
                        ultimaRevision: '14/07/2025',
                      }" />
                      <div style="margin-top: 4px;"><strong>PÁGINAS:</strong> 2 DE 3</div>
                      <div style="margin-top: 2px;"><strong>ANEXOS:</strong> 00</div>
                    </td>
                  </tr>
                </table>
                    </td>
                  </tr>
                  <!-- <template v-if="showAccidents === true"> -->
                  <tr>
                    <td class="subtitle" colspan="16" style="text-align: center">
                      6) ACCIDENTES DE TRABAJO O ENFERMEDADES OCUPACIONALES SUFRIDOS ANTERIORMENTE
                    </td>
                  </tr>
                  <tr style="text-align: center; font-weight: bold">
                    <td colspan="3">EVENTUALIDAD</td>
                    <td colspan="6">DESCRIPCIÓN</td>
                    <td colspan="2">AÑO</td>
                    <td colspan="5">DÍAS PERDIDOS *</td>
                  </tr>
                  <tr>
                    <td colspan="3">
                      ACCIDENTE
                      <input type="radio" v-if="!blankMode" disabled :value="1" v-model="viewHistory.MevAccident1" />
                      ENFERMEDAD
                      <input type="radio" v-if="!blankMode" disabled :value="0" v-model="viewHistory.MevAccident1" />
                    </td>
                    <td colspan="6">
                      <div v-show="viewHistory.MevAccident1 !== null" style="font-weight: bold; margin-top: 5px; text-align: center">
                        {{ viewHistory.MevAccidentDescription1 }}
                      </div>
                      <div v-show="viewHistory.MevAccident1 == null"
                        style="font-weight: bold; margin-top: 5px; text-align: center">
                        NIEGA
                      </div>
                    </td>
                    <td colspan="2">
                      <div v-show="viewHistory.MevAccident1 !== null" style="font-weight: bold; margin-top: 5px; text-align: center">
                        {{ viewHistory.MevAccidentYear1 }}
                      </div>
                      <div v-show="viewHistory.MevAccident1 == null"
                        style="font-weight: bold; margin-top: 5px; text-align: center">
                        NIEGA
                      </div>
                    </td>
                    <td colspan="5">
                      <div v-show="viewHistory.MevAccident1 !== null" style="font-weight: bold; margin-top: 5px; text-align: center">
                        {{ viewHistory.MevAccidentDaysLost1 }}
                      </div>
                      <div v-show="viewHistory.MevAccident1 == null"
                        style="font-weight: bold; margin-top: 5px; text-align: center">
                        NIEGA
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3">
                      ACCIDENTE
                      <input type="radio" v-if="!blankMode" disabled :value="1" v-model="viewHistory.MevAccident2" />
                      ENFERMEDAD
                      <input type="radio" v-if="!blankMode" disabled :value="0" v-model="viewHistory.MevAccident2" />
                    </td>
                    <td colspan="6">
                      <div v-show="viewHistory.MevAccident2 !== null" style="font-weight: bold; margin-top: 5px; text-align: center">
                        {{ viewHistory.MevAccidentDescription2 }}
                      </div>
                      <div v-show="viewHistory.MevAccident2 == null"
                        style="font-weight: bold; margin-top: 5px; text-align: center">
                        NIEGA
                      </div>
                    </td>
                    <td colspan="2">
                      <div v-show="viewHistory.MevAccident2 !== null" style="font-weight: bold; margin-top: 5px; text-align: center">
                        {{ viewHistory.MevAccidentYear2 }}
                      </div>
                      <div v-show="viewHistory.MevAccident2 == null"
                        style="font-weight: bold; margin-top: 5px; text-align: center">
                        NIEGA
                      </div>
                    </td>
                    <td colspan="5">
                      <div v-show="viewHistory.MevAccident2 !== null" style="font-weight: bold; margin-top: 5px; text-align: center">
                        {{ viewHistory.MevAccidentDaysLost2 }}
                      </div>
                      <div v-show="viewHistory.MevAccident2 == null"
                        style="font-weight: bold; margin-top: 5px; text-align: center">
                        NIEGA
                      </div>
                    </td>
                  </tr>
                  <!-- </template> -->
                  <!-- 7) HÁBITOS DE VIDA (FUNCIONES BIOLÓGICAS) -->
                  <tr>
                    <td class="subtitle" colspan="16" style="text-align: center">
                      7) FUNCIONES BIOLÓGICAS
                    </td>
                  </tr>
                  <tr>
                    <td colspan="5">
                      APETITO:
                      <b>
                        {{ viewHistory.TypeLevelAppetiteName }}
                      </b>
                    </td>
                    <td colspan="5">
                      SED:
                      <b>
                        {{ viewHistory.TypeLevelThirstName }}
                      </b>
                    </td>
                    <td colspan="6">
                      ORINA:
                      <b>
                        {{ viewHistory.TypeLevelUrineName }}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="5">
                      DEPOSICIONES:
                      <b>
                        {{ viewHistory.TypeLevelDepositionsName }}
                      </b>
                    </td>
                    <td colspan="5">
                      SUEÑO:
                      <b>
                        {{ viewHistory.TypeLevelSleepName }}
                      </b>
                    </td>
                    <td colspan="6">
                      PERDIDA PESO / OBESIDAD:
                      <b>
                        {{ viewHistory.TypeLevelLostWeightName }}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td class="subtitle" colspan="16" style="text-align: center">
                      8) EVALUACIÓN MÉDICA
                    </td>
                  </tr>
                  <tr style="text-align: center">
                    <td colspan="2"><b>FC (LAT/MIN)</b><br /></td>
                    <td colspan="2">
                      {{ viewHistory.MevHeartRate }}
                    </td>
                    <td colspan="2"><b>FR (RESP/MIN)</b><br /></td>
                    <td>
                      {{ viewHistory.MevBreathingFrecuency }}
                    </td>
                    <td colspan="3"><b>TEMP °C</b><br /></td>
                    <td colspan="3">
                      {{ viewHistory.MevTemperature }}
                    </td>
                    <td><b>SO2 %</b><br /></td>
                    <td colspan="2">
                      {{ viewHistory.MevOxygenSaturation }}
                    </td>
                  </tr>
                  <tr style="text-align: center">
                    <td colspan="2"><b>PA (mmHg)</b><br /></td>
                    <td colspan="2">
                        <div style="display: flex; align-items: center; justify-content: center; margin: auto;">
                        {{ viewHistory.MevPASistol }}
                        <span style="margin: 0 4px">/</span>
                        {{ viewHistory.MevPADiastol }}
                        </div>
                    </td>
                    <td colspan="2"><b>TALLA (cm)</b><br /></td>
                    <td>
                      {{ viewHistory.MevSize }}
                    </td>
                    <td colspan="3"><b>PESO (Kg)</b><br /></td>
                    <td colspan="3">
                      {{ viewHistory.MevWeight }}
                    </td>
                    <td><b>IMC</b><br /></td>
                    <td colspan="2">
                      {{ viewHistory.MevBMI }}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="16" style="padding-bottom: 20px">
                      <b>ANAMNESIS:</b>
                      {{ viewHistory.TypeAnamnesisDescription }}
                    </td>
                  </tr>

                  <!-- AGUDEZA VISUAL -->
                  <tr>
                    <!-- AGUDEZA LEJOS -->
                    <td colspan="2" rowspan="2" style="text-align: center; width: 12%">
                      AGUDEZA VISUAL LEJOS
                    </td>

                    <td style="width: 3%">OD</td>
                    <td colspan="1" style="width: 10%">
                      {{ viewHistory.MevVisualFarRightName }}
                    </td>

                    <!-- CON CORRECTORES -->
                    <td colspan="2" rowspan="2" style="text-align: center; width: 12%">CON CORRECTORES</td>

                    <td style="width: 3%">OD</td>
                    <td colspan="1" style="width: 10%">
                      {{ viewHistory.MevVisualFarRightLenseName }}
                    </td>

                    <!-- AGUDEZA CERCA -->
                    <td colspan="2" rowspan="2" style="text-align: center; width: 12%">
                      AGUDEZA VISUAL CERCA
                    </td>

                    <td style="width: 3%">OD</td>
                    <td colspan="1" style="width: 10%">
                      {{ viewHistory.MevVisualNearRightName }}
                    </td>

                    <td colspan="2" rowspan="2" style="text-align: center; width: 12%">CON CORRECTORES</td>

                    <td style="width: 3%">OD</td>
                    <td colspan="1" style="width: 10%">
                      {{ viewHistory.MevVisualNearRightLenseName }}
                    </td>
                  </tr>

                  <tr>
                    <!-- LEJOS OI -->
                    <td>OI</td>
                    <td colspan="1">
                      {{ viewHistory.MevVisualFarLeftName }}
                    </td>

                    <td>OI</td>
                    <td colspan="1">
                      {{ viewHistory.MevVisualFarLeftLenseName }}
                    </td>

                    <!-- CERCA OI -->
                    <td>OI</td>
                    <td colspan="1">
                      {{ viewHistory.MevVisualNearLeftName }}
                    </td>

                    <td>OI</td>
                    <td colspan="1">
                      {{ viewHistory.MevVisualNearLeftLenseName }}
                    </td>
                  </tr>

                  <!-- EXAMEN FÍSICO -->
                  <tr>
                    <td colspan="3" class="header-cell">DETALLE</td>
                    <td colspan="2" class="header-cell">REVISADO</td>
                    <td colspan="11" class="header-cell">DESCRIPCIÓN</td>
                  </tr>
                  <tr v-for="(item, index) in physicalExamSystems" :key="index">
                    <td colspan="3">{{ item.label }}</td>
                    <td colspan="2" style="text-align: center; position: relative;">
                      <!-- Renderiza el check o la X manualmente para PDF/impresión -->
                      <span
                        v-if="viewHistory[item.checkField] == 1"
                        style="display: inline-block; min-width: 20px; height: 20px; border: 2px solid #222; border-radius: 4px; text-align: center; line-height: 22px; font-size: 16px; font-weight: bold;"
                      >
                        ✔
                      </span>
                      <span
                        v-else
                        style="display: inline-block; min-width: 20px; height: 20px; border: 2px solid #222; border-radius: 4px; text-align: center; line-height: 22px; font-size: 16px; font-weight: bold;"
                      >
                        {{ blankMode ? '' : '✗' }}
                      </span>
                    </td>
                    <td colspan="11">
                      <div v-if="viewHistory[item.checkField] === 0">
                        {{ viewHistory[item.descField] }}
                      </div>
                    </td>
                  </tr>
                  </table>
                  <!-- DIAGNÓSTICOS Y RECOMENDACIONES -->
                  
              </div>
              <div class="page" style="page-break-after: auto; text-transform: uppercase;">
                <div class="watermark">DOCUMENTO CONTROLADO</div>
                  <div style="width: 100%; padding: 0; border: none;">
                      <table class="header-table" style="width: 100%; border-collapse: collapse;">
                  <tr>
                    <td style="
                      width: 20%;
                      vertical-align: middle;
                      text-align: center;
                      border: none;
                      padding: 8px;
                    ">
                      <img src="/static/logo_sp.png" alt="Logo" style="width: 120px; height: auto" />
                    </td>
                    <td style="width: 50%; text-align: center; vertical-align: middle; border: none; padding: 8px;">
                      <div class="title" style="font-size: 11px; font-weight: bold; line-height: 1.3;">FORMATO PARA EXAMEN</div>
                      <div class="title" style="font-size: 11px; font-weight: bold; line-height: 1.3;">MÉDICO OCUPACIONAL DE</div>
                      <div class="title" style="font-size: 11px; font-weight: bold; line-height: 1.3;">PRE – INGRESO</div>
                    </td>
                    <td style="width: 30%; text-align: left; vertical-align: middle; border: none; padding: 8px; font-size: 9pt; line-height: 1.5;">
                      <document-header-control param-name="PdfClinicHistory" :default-data="{
                        codigo: 'SIG-ST-SO-FR-003',
                        version: '08',
                        fechaCreacion: '28/10/2018',
                        ultimaRevision: '14/07/2025',
                      }" />
                      <div style="margin-top: 4px;"><strong>PÁGINAS:</strong> 3 DE 3</div>
                      <div style="margin-top: 2px;"><strong>ANEXOS:</strong> 00</div>
                    </td>
                  </tr>
                </table>
                  </div>
                  <table class="data-table" style="font-size: 8pt; width: 100%; max-width: 100%; table-layout: fixed; margin: 0 auto;">
                  <tr>
                    <td colspan="7" style="vertical-align: top; height: 100px;">
                      <b>DIAGNÓSTICOS</b>
                      <br />
                      <ol v-if="viewHistory.TypeDiagnosisDescription" style="padding-left: 18px;">
                        <li v-for="(diag, idx) in viewHistory.TypeDiagnosisDescription.split('||').filter(d => d.trim())"
                          :key="idx">
                          {{ diag.trim() }}
                        </li>
                      </ol>
                    </td>
                    <td colspan="9" rowspan="2" style="vertical-align: top">
                      <b>REEVALUACIÓN:</b>
                      <div v-if="viewHistory.MevDescriptionReevaluation != '' || viewHistory.MevDescriptionReevaluation != null" style="margin-top: 5px">
                        <!-- {{ viewHistory.MevDescriptionReevaluation }} -->
                        <ol v-if="viewHistory.MevDescriptionReevaluation"  style="padding-left: 18px;">
                        <li
                          v-for="(recom, idx) in viewHistory.MevDescriptionReevaluation.split('||').filter(d => d.trim())"
                          :key="idx">
                          {{ recom.trim() }}
                        </li>
                      </ol>
                      </div>
                      <!-- 
                      <div v-if="
                        (viewHistory.MevStatus == 4 || viewHistory.MevStatus == 2) && viewHistory.MevID > 0 
                      " class="mt-2">
                        <div v-if="reevaluationFiles && reevaluationFiles.length" class="mt-2"
                          style="display: flex; flex-wrap: wrap;">
                          <v-chip v-for="file in reevaluationFiles" :key="file.path" small class="ma-1" outlined
                            @click="openReevaluationFile(file)">
                            <v-icon left small v-if="file.isImage">mdi-image</v-icon>
                            <v-icon left small v-else-if="file.isPdf">mdi-file-pdf-box</v-icon>
                            <v-icon left small v-else-if="file.isWord">mdi-file-word-box</v-icon>
                            <v-icon left small v-else>mdi-file</v-icon>
                            {{ file.name }}
                          </v-chip>
                        </div>
                      </div> -->
                    </td>
                  </tr>
                  <tr>
                    <td colspan="7" style="vertical-align: top; height: 100px;">
                      <b>RECOMENDACIONES:</b><br>
                      <ol v-if="viewHistory.TypeRecommendationsDescription"  style="padding-left: 18px;">
                        <li
                          v-for="(recom, idx) in viewHistory.TypeRecommendationsDescription.split('||').filter(d => d.trim())"
                          :key="idx">
                          {{ recom.trim() }}
                        </li>
                      </ol>
                    </td>
                  </tr>

                  <!-- FACTORES DE RIESGO Y OTROS -->
                  <tr>
                    <td class="subtitle" colspan="16" style="text-align: center">
                      FACTORES DE RIESGO Y RECOMENDACIONES ADICIONALES
                    </td>
                  </tr>
                  <tr>
                    <td colspan="16">
                      <div style="display: flex; align-items: center; margin-bottom: 5px">
                        <b>FACTORES DE RIESGO:</b>
                          <span
                        v-if="viewHistory.MevHasRiskFactors == 1"
                        style="display: inline-block; min-width: 20px; height: 20px; border: 2px solid #222; border-radius: 4px; text-align: center; line-height: 22px; font-size: 16px; font-weight: bold;"
                      >
                        ✔
                      </span>
                      <span
                        v-else
                        style="display: inline-block; min-width: 20px; height: 20px; border: 2px solid #222; border-radius: 4px; text-align: center; line-height: 22px; font-size: 16px; font-weight: bold;"
                      >
                        {{ blankMode ? '' : '✗' }}
                      </span>
                      </div>
                      <ol v-if="viewHistory.TypeRiskFactorsDescription" style="padding-left: 18px;">
                        <li
                          v-for="(riskFact, idx) in viewHistory.TypeRiskFactorsDescription.split('||').filter(d => d.trim())"
                          :key="idx">
                          {{ riskFact.trim() }}
                        </li>
                      </ol>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="6">
                      <b>DIETA:</b>
                        <span
                        v-if="viewHistory.MevDiet == 1"
                        style="display: inline-block; min-width: 20px; height: 20px; border: 2px solid #222; border-radius: 4px; text-align: center; line-height: 22px; font-size: 16px; font-weight: bold;"
                      >
                        ✔
                      </span>
                      <span
                        v-else
                        style="display: inline-block; min-width: 20px; height: 20px; border: 2px solid #222; border-radius: 4px; text-align: center; line-height: 22px; font-size: 16px; font-weight: bold;"
                      >
                        {{ blankMode ? '' : '✗' }}
                      </span>
                    </td>
                    <td colspan="10">
                      <b>GESTANTES:</b>
                        <span
                        v-if="viewHistory.MevPregnant == 1"
                        style="display: inline-block; min-width: 20px; height: 20px; border: 2px solid #222; border-radius: 4px; text-align: center; line-height: 22px; font-size: 16px; font-weight: bold;"
                      >
                        ✔
                      </span>
                      <span
                        v-else
                        style="display: inline-block; min-width: 20px; height: 20px; border: 2px solid #222; border-radius: 4px; text-align: center; line-height: 22px; font-size: 16px; font-weight: bold;"
                      >
                        {{ blankMode ? '' : '✗' }}
                      </span>
                    </td>
                  </tr>

                  <!-- FIRMA HISTORIA CLINICA -->
                  <tr>
                    <td colspan="7" style="vertical-align: bottom; padding-bottom: 40px">
                      <div style="flex: 1; margin-top: 30px; display: flex; justify-content: center;">
                        <div
                          style="font-size: 12px; display: flex; flex-direction: column; justify-content: center; align-items: center; position: relative; margin: 0;">
                        <div
                          style="display: flex; flex-direction: column; justify-content: center; align-items: center; position: relative; max-width: max-content;">
                          <div
                            style="width: 100%; height: 80px; display: flex; justify-content: center; align-items: center; position: relative; margin-bottom: 6px;">
                            <div style="width: 100%; display: flex;">
                              <div
                                style="display: flex; flex-direction: column; justify-content: center; align-items: center; width: 100%; cursor: pointer;">
                                <span v-if="!SignaturePatient && !SignaturePatientDB"
                                  style="height:80px; width: 100%;"></span>
                                <img :src="SignaturePatient" v-if="SignaturePatient" alt="Firma Paciente"
                                  style="max-width: 100%; height: 80px; object-fit: contain; padding: 5px;" />
                                <img :src="SignaturePatientDB" v-if="!SignaturePatient && SignaturePatientDB"
                                  alt="Firma Paciente"
                                  style="max-width: 100%; height: 80px; object-fit: contain; padding: 5px;" />
                              </div>
                              <div
                                style="width: 60px; height: 80px; border: 1px solid #000; text-align: center; display: flex; justify-content: center; align-items: center;">
                                <!-- fingerPrintPatient, fingerPrintPatientDB -->
                                 <img :src="FingerPrintPatient" v-if="FingerPrintPatient" alt="Firma Paciente"
                                  style="max-width: 100%; height: 80px; object-fit: contain; padding: 5px;" />
                                <img :src="FingerPrintPatientDB" v-if="!FingerPrintPatient && FingerPrintPatientDB"
                                  alt="Firma Paciente"
                                  style="max-width: 100%; height: 80px; object-fit: contain; padding: 5px;" />
                              </div>
                            </div>
                          </div>
                          <span style="border-top: 1px solid #000;">
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <span style="font-weight: bold;">Nombre : </span>
                            {{ blankMode ? blankLine : viewHistory.NtpFullName }}
                            &nbsp;&nbsp;&nbsp;&nbsp;
                          </span>
                          <span><span style="font-weight: bold;">DNI : </span>{{ blankMode ? blankLine : viewHistory.PrsDocumentNumber }}</span>
                          <span><span style="font-weight: bold;">Fecha : </span>
                            {{ blankMode ? blankLine : $fun.formatDateView(viewHistory.MevDate) }}</span>
                        </div>
                        </div>
                      </div>
                    </td>
                    <td colspan="9" style="vertical-align: bottom">
                      <template v-if="viewHistory.DocName || blankMode">
                        <div
                          style=" min-height: 120px; display: flex; flex-direction: column; align-items: center; justify-content: flex-end; border-radius: 10px; box-shadow: 0 2px 8px #0001; padding: 18px 10px 10px 10px; background: #fafbfc;">
                          <div style="width: 100%; display: flex; align-items: flex-end; justify-content: center;">
                            <img v-if="SignatureImageDoctor" :src="SignatureImageDoctor" alt="Firma"
                              style="max-width: 100%; max-height: 120px; object-fit: contain; margin-bottom: 6px;" />
                          </div>
                          <div style="border-top: 1.5px solid #222; width: 90%; margin: 12px 0 2px 0;"></div>
                          <div style="font-size: 13px; font-weight: 500; margin-bottom: 2px; text-align: center;">
                            {{ viewHistory.DocName }}</div>
                          <div style="font-size: 11px; color: #888; text-align: center;">Sello y Firma</div>
                        </div>
                      </template>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </section>
      </vue-html2pdf>
    </v-card>

    <!-- Diálogo de firma paciente deshabilitado -->

    <!-- Modal edición encabezado -->
    <v-dialog v-model="editModal" max-width="500px">
      <v-card>
        <s-toolbar label="Editar Datos del Formulario" dark color="#8e8f91" close @close="editModal = false" />
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <s-text v-model="editForm.codigo" label="Código" />
              </v-col>
              <v-col cols="12">
                <s-text v-model="editForm.version" label="Versión" />
              </v-col>
              <v-col cols="12">
                <s-text v-model="editForm.fechaCreacion" label="Fecha de Creación" />
              </v-col>
              <v-col cols="12">
                <s-text v-model="editForm.ultimaRevision" label="Última Revisión" />
              </v-col>
              <v-col cols="12">
                <s-text v-model="editForm.paginas" label="Páginas" />
              </v-col>
              <v-col cols="12">
                <s-text v-model="editForm.anexo" label="Anexo" />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="error" @click="editModal = false">Cancelar</v-btn>
          <v-btn color="success" @click="saveFormData">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Overlay simple mientras sube el PDF -->
    <v-overlay :value="uploading" opacity="0.3">
      <v-card class="pa-4" outlined>
        <v-progress-circular indeterminate color="primary" class="mr-2" />
        <span>Guardando PDF de historia clínica...</span>
      </v-card>
    </v-overlay>
  </div>
</template>

<script>
import VueHtml2pdf from "vue-html2pdf";
import GenUploadFiles from "@/services/General/GenUploadFiles";
import sFingerPrint from "@/components/Utils/RecursosHm/sFingerPrint";
import _sGenParam from "@/services/General/ParameterService";

export default {
  name: "PdfClinicalHistory",
  components: {
    VueHtml2pdf,
    sFingerPrint,
  },
  props: {
    history: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      SignaturePatient: null,
      FingerPrintPatient: null,
      SignatureImageDoctor: null,
      SignaturePatientDB: null,
      FingerPrintPatientDB: null,

      dialogSignaturePatient: false,
      blankMode: false,
      blankLine: "____________________",
      downloadMode: 1, // 1 = descargar/imprimir, 0 = guardar en servidor
      serverUploadParameter: "routeClinicHistories",
      progress: 0,
      uploading: false,
      pendingUploadResolve: null,
      pendingUploadReject: null,
      signatureLoadingPromise: null,

      formData: {},
      editForm: {
        codigo: "",
        version: "",
        fechaCreacion: "",
        ultimaRevision: "",
        paginas: "",
        anexo: "",
      },
      editModal: false,
      dataAttributes: {},
      htmlToPdfOptions: {
        margin: [0.1, 0.2, 0.1, 0.2],
        filename: `historia_clinica.pdf`,
        jsPDF: {
          unit: "in",
          format: "a4",
          orientation: "portrait",
        },
        html2canvas: {
          useCORS: true,
          scale: 4,
          letterRendering: true, // Mejora el renderizado de texto
        },
      },
      physicalExamSystems: [
        {
          label: "CABEZA Y CUELLO",
          checkField: "MevPhysicalHead",
          descField: "MevHeadDesc",
        },
        {
          label: "PIEL Y FANERAS",
          checkField: "MevPhysicalSkin",
          descField: "MevSkinDesc",
        },
        {
          label: "OJOS",
          checkField: "MevPhysicalEyes",
          descField: "MevEyesDesc",
        },
        {
          label: "NARIZ",
          checkField: "MevPhysicalNose",
          descField: "MevNoseDesc",
        },
        {
          label: "OÍDOS",
          checkField: "MevPhysicalEars",
          descField: "MevEarsDesc",
        },
        {
          label: "BOCA",
          checkField: "MevPhysicalMouth",
          descField: "MevMouthDesc",
        },
        {
          label: "TÓRAX Y PULMONES",
          checkField: "MevPhysicalChest",
          descField: "MevChestDesc",
        },
        {
          label: "CARDIOVASCULAR",
          checkField: "MevPhysicalCardiovascular",
          descField: "MevCardiovascularDesc",
        },
        {
          label: "ABDOMEN",
          checkField: "MevPhysicalAbdomen",
          descField: "MevAbdomenDesc",
        },
        {
          label: "AP. GENITOURINARIO",
          checkField: "MevPhysicalGenitourinary",
          descField: "MevGenitourinaryDesc",
        },
        {
          label: "AP. MUSCULO ESQUELÉTICO",
          checkField: "MevPhysicalOsteomuscular",
          descField: "MevOsteomuscularDesc",
        },
        {
          label: "COLUMNA VERTEBRAL",
          checkField: "MevPhysicalColumn",
          descField: "MevColumnDesc",
        },
        {
          label: "MIEMBROS SUPERIORES",
          checkField: "MevPhysicalMembersUpper",
          descField: "MevMemberUpperDesc",
        },
        {
          label: "MANOS Y UÑAS",
          checkField: "MevPhysicalHands",
          descField: "MevHandsDesc",
        },
        {
          label: "MIEMBROS INFERIORES",
          checkField: "MevPhysicalMembersLower",
          descField: "MevMemberLowerDesc",
        },
        {
          label: "MARCHA",
          checkField: "MevPhysicalMarcha",
          descField: "MevMarchaDesc",
        },
      ],
      doctorSignatures: {}, // { 'NOMBRE': base64 }
    };
  },
  watch: {
    history: {
      handler(newVal) {
        this.syncHistoryAssets(newVal);
        // Actualizar firmas/huellas del paciente si existen
        this.SignaturePatientDB =
          newVal && newVal.MevSignaturePatient
            ? newVal.MevSignaturePatient
            : null;
        this.FingerPrintPatientDB =
          newVal && newVal.MevFingerPrintPatient
            ? newVal.MevFingerPrintPatient
            : null;
      },
      deep: true,
    },
  },
  computed: {
    viewHistory() {
      return this.blankMode ? this.blankValue(this.history) : this.history;
    },
    pdfFileName() {
      const doc = this.history?.MevDocumentNumber || "HistoriaClinica";
      return `${doc}.pdf`;
    },
  },
  methods: {
    // Encabezado editable (igual patrón que PdfAsignation)
    openEditModal() {
      if (!this.$fun.isAdmin()) return;
      this.editForm = {
        ...this.formData,
      };
      this.editModal = true;
    },
    saveFormData() {
      const data = {
        ...this.dataAttributes,
      };
      data.PrmValue = JSON.stringify(this.editForm);
      _sGenParam.save(data, this.$fun.getUserID()).then((resp) => {
        if (resp.status === 200) {
          this.editModal = false;
          this.getDataHeader();
        }
      });
    },
    getDataHeader() {
      _sGenParam
        .listoptions(
          {
            Search: "PdfClinicHistory",
          },
          this.$fun.getUserID()
        )
        .then((resp) => {
          if (resp.status === 200 && resp.data.length) {
            this.dataAttributes = resp.data[0];
            this.formData =
              {
                ...JSON.parse(this.dataAttributes.PrmValue),
              } || {};
          }
        });
    },

    // Firma/huella paciente
    openSignaturePatientDialog() {
      // Deshabilitado: no abrir modal ni ejecutar nada
      return;
    },
    handleSignaturePatient(image) {
      this.SignaturePatient = image;
      this.dialogSignaturePatient = false;
    },
    handleFingerprintPatient(image) {
      this.FingerPrintPatient = image;
    },

    // PDF
    blankValue(value, key = "") {
      if (Array.isArray(value)) return value.map((v) => this.blankValue(v, key));
      if (value && typeof value === "object") {
        if (value instanceof Date) return null;
        const out = {};
        Object.keys(value).forEach((k) => {
          out[k] = this.blankValue(value[k], k);
        });
        return out;
      }
      if (typeof value === "boolean") return false;
      if (typeof value === "number") return null;
      return "";

    },
    async downloadBlank() {
      this.blankBackup = {
        sp: this.SignaturePatient,
        spdb: this.SignaturePatientDB,
        fp: this.FingerPrintPatient,
        fpdb: this.FingerPrintPatientDB,
        sd: this.SignatureImageDoctor,
      };
      this.SignaturePatient = null;
      this.SignaturePatientDB = null;
      this.FingerPrintPatient = null;
      this.FingerPrintPatientDB = null;
      this.SignatureImageDoctor = null;
      this.blankMode = true;
      this.downloadMode = 1;
      await this.$nextTick();
      this.$refs.html2Pdf.generatePdf();
    },
    restoreAfterBlank() {
      if (!this.blankMode) return;
      const b = this.blankBackup || {};
      this.blankMode = false;
      this.SignaturePatient = b.sp;
      this.SignaturePatientDB = b.spdb;
      this.FingerPrintPatient = b.fp;
      this.FingerPrintPatientDB = b.fpdb;
      this.SignatureImageDoctor = b.sd;
    },
    downloadPdf(mode, uploadParameter = null) {
      this.downloadMode = mode;
      if (uploadParameter) {
        this.serverUploadParameter = uploadParameter;
      }
      this.ensurePdfAssetsReady().then(() => {
        this.$refs.html2Pdf.generatePdf();
      });
    },
    async savePdfToServer(uploadParameter = "routeClinicHistories") {
      this.serverUploadParameter = uploadParameter;
      this.downloadMode = 0;
      await this.ensurePdfAssetsReady();
      await this.$nextTick();

      return new Promise((resolve, reject) => {
        this.pendingUploadResolve = resolve;
        this.pendingUploadReject = reject;
        this.$nextTick(() => {
          this.$refs.html2Pdf.generatePdf();
        });
      });
    },
    printDirectly() {
      // Imprimir directamente el contenido completo del formato médico
      // Buscar el contenido dentro del componente vue-html2pdf
      const printContent = this.$el.querySelector('.formato-medico-container');
      if (!printContent) {
        console.error('No se encontró el contenido a imprimir');
        return;
      }

      // Al imprimir con innerHTML, el estado `checked` puede perderse porque es
      // una propiedad (no un atributo). Clonamos el DOM y copiamos el estado
      // como atributo para que el HTML impreso lo conserve.
      const printableClone = printContent.cloneNode(true);
      const originalInputs = printContent.querySelectorAll('input[type="radio"], input[type="checkbox"]');
      const clonedInputs = printableClone.querySelectorAll('input[type="radio"], input[type="checkbox"]');
      for (let i = 0; i < originalInputs.length && i < clonedInputs.length; i++) {
        const isChecked = !!originalInputs[i].checked;
        clonedInputs[i].checked = isChecked;
        if (isChecked) clonedInputs[i].setAttribute('checked', 'checked');
        else clonedInputs[i].removeAttribute('checked');
      }
      
      const printWindow = window.open('', '', 'height=800,width=1200');
      printWindow.document.write('<html><head><title>Historia Clínica Ocupacional</title>');
      printWindow.document.write(`
        <style>
          * { margin: 0; padding: 0; box-sizing: border-box; }
          body { font-family: Arial, sans-serif; }
          .formato-medico-container { background-color: #fff; padding: 8px; }
          .formato-medico { font-family: Arial, sans-serif; font-size: 8pt; }
          .page { position: relative; padding: 8px; margin-bottom: 10px; background: white; page-break-after: always; width: 210mm; min-height: 297mm; box-shadow: 0 0 5px rgba(0,0,0,0.1); height: 827px; }
          .page:last-child { page-break-after: auto; }
          .header-table, .data-table { width: 100%; border-collapse: collapse; margin-top: 2px; }
          .header-table td, .data-table td { border: 1px solid black; padding: 2px; vertical-align: top; }
          .title { font-size: 11px; font-weight: bold; text-align: center; margin: 2px 0; line-height: 1.1; }
          .subtitle { font-size: 8pt; font-weight: bold; background-color: #f0f0f0; padding: 2px; margin-top: 5px; border: 1px solid black; }
          .header-cell { font-weight: bold; background-color: #eee; text-align: center; }
          .watermark { position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) rotate(-45deg);
            opacity: 0.18;
            font-size: 75px;
            pointer-events: none;
            user-select: none;
            z-index: 1;
            color: red;
            font-weight: bold;
            white-space: nowrap; }
          .custom-checkbox { width: 18px; height: 18px; min-width: 18px; appearance: none; border: 2px solid #d1d5db; border-radius: 4px; position: relative; background-color: #fee; border-color: #ef4444; }
          .custom-checkbox::before, .custom-checkbox::after { content: ""; position: absolute; top: 50%; left: 50%; width: 12px; height: 2px; background-color: #ef4444; }
          .custom-checkbox::before { transform: translate(-50%, -50%) rotate(45deg); }
          .custom-checkbox::after { transform: translate(-50%, -50%) rotate(-45deg); }
          .custom-checkbox:checked { background-color: blue; border-color: blue; }
          .custom-checkbox:checked::before { content: ""; top: 3px; left: 7px; width: 5px; height: 10px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); background-color: transparent; }
          .custom-checkbox:checked::after { display: none; }

          /* Radios: estilo sutil y printable */
          input[type="radio"] {
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            width: 12px;
            height: 12px;
            border: 1px solid #111;
            border-radius: 50%;
            background: #fff;
            position: relative;
            vertical-align: middle;
            margin: 0 3px;
            print-color-adjust: exact;
            -webkit-print-color-adjust: exact;
          }

          input[type="radio"]:disabled {
            opacity: 1;
          }

          input[type="radio"]:checked::after,
          input[type="radio"][checked]::after {
            content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            width: 6px;
            height: 6px;
            background: #111;
            border-radius: 50%;
            transform: translate(-50%, -50%);
            print-color-adjust: exact;
            -webkit-print-color-adjust: exact;
          }

          img { max-width: 100%; height: auto; }
          @media print { 
            .page { border: none; box-shadow: none; margin: 0; padding: 10px; }
            body { print-color-adjust: exact; -webkit-print-color-adjust: exact; }

            input[type="radio"] {
              -webkit-appearance: none !important;
              -moz-appearance: none !important;
              appearance: none !important;
              print-color-adjust: exact !important;
              -webkit-print-color-adjust: exact !important;
            }
          }
        </style>
      `);
      printWindow.document.write('</head><body>');
      printWindow.document.write(printableClone.innerHTML);
      printWindow.document.write('</body></html>');
      printWindow.document.close();
      
      // Esperar a que se cargue el contenido antes de imprimir
      setTimeout(() => {
        printWindow.focus();
        printWindow.print();
        printWindow.close();
      }, 500);
    },
    onProgress(p) {
      this.progress = p;
    },
    async beforeDownload({ html2pdf, options, pdfContent }) {
      if (this.downloadMode === 0) {
        // Guardar en servidor usando la ruta configurada
        this.uploading = true;
        html2pdf()
          .set(options)
          .from(pdfContent)
          .toPdf()
          .get("pdf")
          .then(async (pdf) => {
            try {
              const blob = pdf.output("blob");
              const uniqueName = /\.pdf$/i.test(this.pdfFileName)
                ? this.pdfFileName
                : `${this.pdfFileName}.pdf`;

              const resp = await GenUploadFiles.upload(
                blob,
                uniqueName,
                this.serverUploadParameter,
                true
              );

              // Si quieres guardar el nombre del archivo en la historia, podrías emitir un evento
              // this.$emit('pdf-saved', resp.data.fileName);

              this.$fun.alert(
                "PDF de historia clínica guardado correctamente",
                "success"
              );
              this.pendingUploadResolve?.(resp);
            } catch (err) {
              console.error("Error subiendo PDF historia clínica:", err);
              this.$fun.alert(
                "Error al guardar el PDF de la historia clínica",
                "error"
              );
              this.pendingUploadReject?.(err);
            } finally {
              this.uploading = false;
              this.pendingUploadResolve = null;
              this.pendingUploadReject = null;
            }
          });
        // Cancelar descarga automática
        return false;
      } else {
        // Descarga local normal
        html2pdf()
          .set(options)
          .from(pdfContent)
          .toPdf()
          .get("pdf")
          .then((pdf) => {
            // Podrías agregar numeración de páginas aquí si quieres
          })
          .save()
          .then(() => this.restoreAfterBlank(), () => this.restoreAfterBlank());
      }
    },
    calculateAge(birthDate) {
      if (!birthDate) return "";
      let today = new Date();
      let birth = new Date(birthDate);
      let age = today.getFullYear() - birth.getFullYear();
      let m = today.getMonth() - birth.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
        age--;
      }
      return age;
    },
    calculateBMI() {
      if (this.history.MevWeight > 0 && this.history.MevSize > 0) {
        // Size in cm to meters
        let sizeM = this.history.MevSize / 100;
        this.history.MevBMI = (
          this.history.MevWeight / (sizeM * sizeM).toFixed(2)
        ).toFixed(2);
      }
    },
    getBMIColor(bmi) {
      if (bmi < 18.5) return "blue";
      if (bmi < 25) return "green";
      if (bmi < 30) return "orange";
      return "red";
    },
    getBMIDescription(bmi) {
      if (bmi < 16.99) return "Muy Bajo peso";
      if (bmi < 17.99) return "Bajo peso";
      if (bmi < 24.99) return "Normal";
      if (bmi < 29.99) return "Sobrepeso";
      if (bmi < 34.99) return "Obesidad I";
      if (bmi < 39.99) return "Obesidad II";
      return "Obesidad III";
    },
    getPAColor(pasistol, padiastol) {
      if (pasistol < 130 && padiastol <= 80) return "green";
      // if (pasistol >= 120 && ) return "orange";
      return "red";
    },
    getPADescription(pasistol, padiastol) {
      if (pasistol < 130 && padiastol <= 80) return "Normal";
      if (
        (pasistol >= 130 && pasistol < 140) ||
        (padiastol > 80 && padiastol < 90)
      )
        return "Hipertensión Etapa I";
      if (pasistol >= 140 || padiastol >= 90) return "Hipertensión Etapa II";
      return "No Diagnosticada";
    },
    getFRColor(fr) {
      if (fr < 12) return "blue";
      if (fr <= 20) return "green";
      return "red";
    },
    getFRDescription(fr) {
      if (fr < 12) return "BRADIPNEA";
      if (fr <= 20) return "EUPNEA";
      return "TAQUIPNEA";
    },
    getFCColor(fc) {
      if (fc < 60) return "blue";
      if (fc <= 100) return "green";
      return "red";
    },
    getFCDescription(fc) {
      if (fc < 60) return "BRADICARDIA";
      if (fc <= 100) return "NORMOCARDIA";
      return "TAQUICARDIA";
    },
    getTEMPColor(temp) {
      if (temp < 36.5) return "#22E9FC";
      if (temp < 37.5) return "green";
      if (temp <= 37.9) return "#E2B70A";
      if (temp <= 39.9) return "orange";
      return "red";
    },
    getTEMPDescription(temp) {
      if (temp < 36.5) return "HIPOTERMIA";
      if (temp < 37.5) return "NORMOTERMIA";
      if (temp <= 37.9) return "FEBRÍCULA";
      if (temp <= 39.9) return "FIEBRE";
      return "HIPERTERMIA";
    },
    getSO2Color(so2) {
      if (so2 >= 95 && so2 <= 100) return "green";
      if (so2 >= 91 && so2 <= 94) return "orange";
      if (so2 >= 86 && so2 <= 90) return "red";
      if (so2 < 86) return "darkred";
    },
    getSO2Description(so2) {
      if (so2 >= 95 && so2 <= 100) return "NORMAL";
      if (so2 >= 91 && so2 <= 94) return "HIPOXIA LEVE";
      if (so2 >= 86 && so2 <= 90) return "HIPOXIA MODERADA";
      if (so2 < 86) return "HIPOXIA GRAVE";
      return "NO DETERMINADA";
    },
    validateHeartRate(val) {
      if (!val) return;
      let num = parseInt(val);
      if (val.toString().startsWith("1")) {
        if (num > 250) {
          this.history.MevHeartRate = 250;
          this.$fun.alert(
            "La frecuencia cardiaca no puede ser mayor a 250",
            "warning"
          );
        }
      }
    },
    syncHistoryAssets(history = this.history) {
      this.loadDoctorSignatures();
      this.signatureLoadingPromise = this.loadPrimaryDoctorSignature(history);
      return this.signatureLoadingPromise;
    },
    async ensurePdfAssetsReady() {
      if (!this.signatureLoadingPromise) {
        this.syncHistoryAssets(this.history);
      }

      try {
        await this.signatureLoadingPromise;
      } finally {
        await this.$nextTick();
      }
    },
    async loadPrimaryDoctorSignature(history = this.history) {
      const doctorName = history?.DocName;

      if (!doctorName) {
        this.SignatureImageDoctor = null;
        return null;
      }

      try {
        const base64 = await GenUploadFiles.getFile(
          "routeSignatures",
          doctorName,
          true
        );
        this.SignatureImageDoctor = base64 || null;
        return this.SignatureImageDoctor;
      } catch (error) {
        this.SignatureImageDoctor = null;
        console.error("Error al obtener firma del doctor:", error);
        return null;
      }
    },
    async loadDoctorSignatures() {
      // Carga la firma de cada doctor en AllDoctors
      this.doctorSignatures = {};
      if (!this.history.DocName) return;
      const names = this.history.DocName.split(",")
        .map((n) => n.trim())
        .filter((n) => n);
      for (const name of names) {
        try {
          const base64 = await GenUploadFiles.getFile(
            "routeSignatures",
            name,
            true
          );
          this.$set(this.doctorSignatures, name, base64);
        } catch (e) {
          this.$set(this.doctorSignatures, name, null);
        }
      }
    },
  },
  async created() {
    // Cargar parámetros de encabezado
    this.getDataHeader();

    if (this.history.MevSignaturePatient) {
      this.SignaturePatientDB = this.history.MevSignaturePatient;
    }
    if (this.history.MevFingerPrintPatient) {
      this.FingerPrintPatientDB = this.history.MevFingerPrintPatient;
    }
    await this.syncHistoryAssets(this.history);
    const boolFields = [
      "MevTobaccoType",
      "MevAlcoholType",
      "MevIsAllergy",
      "MevFoodAllergy",
      "MevMedicationAllergy",
      "MevIsTuberculosis",
      "MevIsChronicBronchitis",
      "MevIsSeizures",
      "MevIsDiabetes",
      "MevIsBloodPressure",
      "MevIsNeoplasm",
      "MevIsAsthma",
      "MevIsHepatitis",
      "MevIsEts",
      "MevPhysicalHead",
      "MevPhysicalSkin",
      "MevPhysicalEyes",
      "MevPhysicalNose",
      "MevPhysicalEars",
      "MevPhysicalMouth",
      "MevPhysicalChest",
      "MevPhysicalCardiovascular",
      "MevPhysicalAbdomen",
      "MevPhysicalGenitourinary",
      "MevPhysicalOsteomuscular",
      "MevPhysicalColumn",
      "MevPhysicalMembersUpper",
      "MevPhysicalHands",
      "MevPhysicalMembersLower",
      "MevPhysicalMarcha",
      "MevHasRiskFactors",
      "MevDiet",
      "MevPregnant",
    ];
    boolFields.forEach((f) => {
      if (typeof this.history[f] === "boolean") {
        this.history[f] = this.history[f] ? 1 : 0;
      }
    });
  },
};
</script>

<style scoped>
.formato-medico-container {
  background-color: #fff;
  padding: 8px;
}

.formato-medico {
  font-family: Arial, sans-serif;
  font-size: 8pt;
  position: relative;
}

.page {
  padding: 8px;
  margin-bottom: 10px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
  background: white;
  position: relative;
  overflow: hidden; /* evita que watermark/elementos absolutos se salgan */
  page-break-after: always;
  break-after: page;
}

.page:last-of-type {
  page-break-after: auto;
  break-after: auto;
}

.header-table,
.data-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 2px;
}

.header-table td,
.data-table td {
  border: 1px solid black;
  padding: 2px;
  vertical-align: top;
}

.title {
  font-size: 11px;
  font-weight: bold;
  text-align: center;
  margin: 2px 0;
  line-height: 1.1;
}

.subtitle {
  font-size: 8pt;
  font-weight: bold;
  background-color: #f0f0f0;
  padding: 2px;
  margin-top: 5px;
  border: 1px solid black;
}

.header-cell {
  font-weight: bold;
  background-color: #eee;
  text-align: center;
}

.watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
  opacity: 0.18;
  font-size: 75px;
  pointer-events: none;
  user-select: none;
  z-index: 1;
  color: red;
  font-weight: bold;
  white-space: nowrap;
}

.custom-checkbox {
  width: 18px;
  height: 18px;
  min-width: 18px;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  border: 2px solid #d1d5db;
  border-radius: 4px;
  position: relative;
  transition: all 0.2s ease;
  background-color: #fee;
  border-color: #ef4444;
}

.custom-checkbox:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

/* X por defecto (cuando NO está marcado) */
.custom-checkbox::before,
.custom-checkbox::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 12px;
  height: 2px;
  background-color: #ef4444;
}

.custom-checkbox::before {
  transform: translate(-50%, -50%) rotate(45deg);
}

.custom-checkbox::after {
  transform: translate(-50%, -50%) rotate(-45deg);
}

/* Cuando está marcado: oculta la X y muestra el check */
.custom-checkbox:checked {
  background-color: blue;
  border-color: blue;
}

.custom-checkbox:checked::before {
  content: "";
  top: 3px;
  left: 7px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  background-color: transparent;
}

.custom-checkbox:checked::after {
  display: none;
}

/* Hover effects */
.custom-checkbox:not(:disabled):hover {
  border-color: #dc2626;
  background-color: #fecaca;
}

.custom-checkbox:checked:not(:disabled):hover {
  background-color: #1c76c1;
  border-color: #1c76c1;
}

@media print {
  .formato-medico-container {
    background-color: #fff;
    padding: 0;
  }

  .formato-medico {
    font-size: 9pt;
  }

  .page {
    border: none;
    box-shadow: none;
    margin: 0;
    padding: 8px;
    width: 100%;
    overflow: hidden;
    page-break-after: always;
    break-after: page;
    page-break-inside: avoid;
    break-inside: avoid-page;
  }

  .page:last-of-type {
    page-break-after: auto;
    break-after: auto;
  }

  .watermark {
    /* En impresión, asegurar que la marca de agua quede dentro de la página */
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: rotate(-45deg);
  }
}
</style>
